export default {
    primary: {
        bg: 'primary_2',
        color: 'neutral_0',
    },
    error: {
        bg: 'secondary_2',
        color: 'neutral_0',
    },
    warning: {
        bg: 'yellow_3',
        color: 'yellow_1',
        borderColor: 'yellow_2',
        border: 'solid 1px',
    },
    success: {
        bg: 'cyan_3',
        color: '#56bdba',
        borderColor: 'cyan_2',
        border: 'solid 1px',
    },
    alertThatUsesColoursThatArentInTheStyleguide: {
        bg: '#e8fff7',
        color: '#56bdba',
        border: 'solid 1px',
        borderColor: '#88deca',
    },
};
